exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-57d58d06] .v-slide-group__content{justify-content:center}", ""]);

// exports
